export enum VendingFormField {
    EVENTID='event_id',
    STATUS='status'
}
export type VendingFormValues = {
   [VendingFormField.EVENTID]:string
   [VendingFormField.STATUS]:string

};